import React from 'react'
import cookie from 'react-cookie'
import { browserHistory } from 'react-router'
import CSSModules from 'react-css-modules'
import styles from './loadingView.css'
import BackgroundTester from '../componentKit2/BackgroundTester'
import { domen } from '../../config.js'

const defaultBg = <img className={styles.alfaBg} src="/assets/img/els/els-bg2.jpg" alt=""/>

const LoadingView = ({title, logout, test, toSignup, isAlfa, taskBack}) => {
  const isUnipro = domen.isUnipro
  const isTele2Lk = domen.isTele2
  let bg = defaultBg;
  return(<div>
    <div className={styles.layoutEntry}>
      <div className={styles.gridEntryHeader}>
        <div className={styles.gridCellTodaymeLogo}>
            <img className={styles.uniproLogo}
                 src="/assets/img/els/logo.svg" alt=""
            />
          {/*  <svg className={styles.svgIconLogoWeb}>
              <use xlinkHref="#ys_logo_web"></use>
            </svg>*/}

        </div>
      </div>
      <div className={styles.entryMin}>
        <div className={styles.entryInner}>

          <div className={styles.entryBox}>

            <div className={styles.entryHeader}>
              <h2 className={isAlfa ? styles.entryTitleCenterAlfa : styles.entryTitleCenter}>{title}</h2>
            </div>

            {title === 'Загружается...' &&
              <div className={styles.textCenter}>
                <div className={styles.loaderMain}></div>
              </div>
            }

            {(logout || title === 'Если вы видите это окно, значит мы делаем личный кабинет для вас удобнее! Напишите нам в чат тех поддержки (внизу справа) или на почту av@todayme.ru') &&

              <div>
                <br/>
                <div className={styles.buttonPrimaryWide} onClick={e => {
                  cookie.remove('token', { path: '/' })
                  cookie.remove('txId', { path: '/' })
                  cookie.remove('role', { path: '/' })
                  cookie.remove('program', { path: '/' })
                  cookie.remove('packageType', { path: '/' })
                  cookie.remove('promoName', { path: '/' })
                  cookie.remove('share', { path: '/' })
                  cookie.remove('general', { path: '/' })
                  cookie.remove('tester', { path: '/' })
                  if(test){
                  cookie.remove('currentSeason', { path: '/' })
                  cookie.save('currentSeason', 3, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
                  }
                  if (toSignup) {
                    browserHistory.push('/signup')
                  } else {
                    browserHistory.push('/')
                  }
                }}>
                  Вернуться на главный сайт
                </div>
              </div>
            }
            {taskBack &&
              <div>
                <br/>
                <div className={styles.buttonActionWide} onClick={e => {
                  browserHistory.push('/task')
                }}>
                  К заданиям
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      {cookie.load('tester')
        ? <BackgroundTester />
        : <div className={styles.entryBg}>
          {bg}
        </div>
      }
    </div>
  </div>)
}

export default CSSModules(LoadingView, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/componentKit/LoadingView.js